

















import { defineComponent } from '@nuxtjs/composition-api';
import IconGridView from '~/components/General/IconGridView.vue';
import IconListView from '~/components/General/IconListView.vue';
import {
  useUiState,
} from '~/composables';

export default defineComponent({
  components: {
    IconGridView,
    IconListView,
  },
  setup() {
    const { isProductCatalogGridView, toggleProductCatalogGridView } = useUiState();

    return {
      isProductCatalogGridView,
      toggleProductCatalogGridView,
    };
  },
});
